export const OPERATION_CATALOG = {
  1: "GetChunk",
  2: "StartWrite",
  3: "FinalizeWrite",
  4: "CopyFile",
  5: "CreateFolder",
  6: "Share",
  7: "UpdateShare",
  9: "AddRole",
  10: "UpdateRole",
  11: "RemoveRole",
  12: "AddTeam",
  13: "UpdateTeam",
  14: "RemoveTeam",
  15: "SetRolesToUser",
  16: "MoveFile",
  17: "RenameFile",
  18: "RestoreVersion",
  20: "RenameFolder",
  21: "MoveFolder",
  22: "UpdateTags",
  23: "AddComment",
  24: "RemoveComment",
  25: "Files",
  27: "ValidateCoupon",
  28: "RemoveVersion",
  29: "RemoveOrganizationUser",
  30: "BlockUser",
  31: "UnblockUser",
  37: "Pins",
  65: "Logs",
  121: "Ysentinel",
};

export const OPERATION_CLASS = {
  read: ["GetChunk"],
  write: ["StartWrite", "FinalizeWrite", "RestoreVersion"],
  structure: ["CreateFolder", "MoveFile", "MoveFolder", "RenameFile", "RenameFolder", "CopyFile"],
  share: ["Share", "UpdateShare"],
  destructive: ["RemoveVersion", "RemoveComment", "RemoveOrganizationUser", "BlockUser", "RemoveRole", "RemoveTeam"],
  admin: ["AddRole", "UpdateRole", "AddTeam", "UpdateTeam", "SetRolesToUser", "UnblockUser"],
  tag: ["UpdateTags"],
  comment: ["AddComment", "UpdateComment", "RemoveComment"],
};

// Country → IANA timezone fallback.
export const COUNTRY_TZ = {
  India: "Asia/Kolkata",
  Singapore: "Asia/Singapore",
  Japan: "Asia/Tokyo",
  Germany: "Europe/Berlin",
  Spain: "Europe/Madrid",
  "United Kingdom": "Europe/London",
  "United States": "America/New_York",
  Mexico: "America/Mexico_City",
  Ireland: "Europe/Dublin",
  "United Arab Emirates": "Asia/Dubai",
  UAE: "Asia/Dubai",
  Russia: "Europe/Moscow",
  "North Korea": "Asia/Pyongyang",
  Nigeria: "Africa/Lagos",
  Vietnam: "Asia/Ho_Chi_Minh",
};

export const PRIVILEGED_OP_TYPES = [
  "AddRole", "UpdateRole", "SetRolesToUser", "UpdateShare", "BlockUser", "RemoveOrganizationUser",
];


